// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__7dWP1","display":"Timer_display__R69sP","controls":"Timer_controls__dBZwc","btn":"Timer_btn__0-5GY","btnSuccess":"Timer_btnSuccess__kphC3"};